import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.mjs';

function createTimeout(producer, events) {
  return new Promise((resolve, reject) => {
    setTimeout(async () => {
      if (events.length === 1) {
        resolve(null);
        return;
      }
      try {
        const result = await producer.produceBatch({
          events
        });
        resolve(result);
      } catch (err) {
        reject(err);
      }
    }, 0);
  });
}
class Batcher {
  constructor(producer) {
    _defineProperty(this, "events", []);
    _defineProperty(this, "timeoutPromise", null);
    this.producer = producer;
  }
  async add(event) {
    this.events.push(event);
    if (!this.timeoutPromise) {
      this.timeoutPromise = createTimeout(this.producer, this.events);
    }
    try {
      const result = await this.timeoutPromise;
      return result;
    } finally {
      this.events = [];
      this.timeoutPromise = null;
    }
  }
}

export { Batcher };
